module.exports = __webpack_public_path__ + "src/assets/img/pb_boleto_flash_mobile.f80b4790.svg";